import { Broadcast } from "./broadcast";
import { EventBus } from "./eventbus";
import { debugInfo } from "../utils/log";
import { g } from "../const/globalThis";
/** 设置Panda全局配置 */ export function setConfig(params) {
    var _params, _params1, _params2;
    if ((_params = params) === null || _params === void 0 ? void 0 : _params.cookieKey) {
        g.__PANDA.cookieKey = params.cookieKey;
        debugInfo("setConfig cookieKey: ".concat(params.cookieKey));
    }
    if (params && typeof params.logLevel !== "undefined") {
        g.__PANDA.logLevel = params.logLevel;
    }
    if ((_params1 = params) === null || _params1 === void 0 ? void 0 : _params1.langList) {
        g.__PANDA.langList = params.langList;
        debugInfo("setConfig langList: ".concat(JSON.stringify(params.langList)));
    }
    if ((_params2 = params) === null || _params2 === void 0 ? void 0 : _params2.defaultLang) {
        g.__PANDA.defaultLang = params.defaultLang;
        debugInfo("setConfig defaultLang: ".concat(params.defaultLang));
    }
}
// 兼容处理
export var pandaEvent = typeof BroadcastChannel === "function" ? new Broadcast() : new EventBus();
export { i18nMapping } from "./mapping";
